import { render, staticRenderFns } from "./orgReservation.vue?vue&type=template&id=048d66dc&scoped=true"
import script from "./orgReservation.vue?vue&type=script&lang=js"
export * from "./orgReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048d66dc",
  null
  
)

export default component.exports